export default __webpack_public_path__ + "static/media/cipolle.940093bd.mp3";